module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('p', [_vm._v("Page not found")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4abfe799","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
// module id = 30
// module chunks = 0